import {AppState} from "../store";

export const getContainerStatusShutInPageFilter = (state: AppState) => state.containerStatusShutInPage.filter
export const getContainerStatusShutInPageState = (state: AppState) => state.containerStatusShutInPage.state
